import { render } from "./PortfolioPage.vue?vue&type=template&id=0eacae30&scoped=true"
import script from "./PortfolioPage.vue?vue&type=script&lang=js"
export * from "./PortfolioPage.vue?vue&type=script&lang=js"

import "./PortfolioPage.vue?vue&type=style&index=0&id=0eacae30&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0eacae30"]])

export default __exports__